export default __webpack_public_path__ + "static/media/Print-documentation.0ab842e3.md";